import { render, staticRenderFns } from "./AggrConfigs.vue?vue&type=template&id=3178089f&"
import script from "./AggrConfigs.vue?vue&type=script&lang=js&"
export * from "./AggrConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports